import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {AuthCheck} from '../../helpers'
import {SearchCalendarClient} from '../../api'

const SERVICE_URL = window.ENVVARS.REACT_APP_SERVICE_URL
const searchCalendarClient = new SearchCalendarClient(SERVICE_URL)

const initialState = {
  loading: false,
  error: null,
  calendar: null,
}

// Async Thunks
export const calendarGetAll = createAsyncThunk('calendar/getAll', async (params, {dispatch}) => {
  try {
    dispatch(setLoading(true))
    const response = await searchCalendarClient.getAll(params)
    dispatch(setCalendarList(response))
    return response
  } catch (error) {
    AuthCheck(error)
    dispatch(setError(error))
    throw error
  }
})

// Slice
const calendarSlice = createSlice({
  name: 'calendar',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
      state.loading = false
    },
    setCalendarList: (state, action) => {
      state.calendar = action.payload
      state.loading = false
    },
    resetState: (state) => {
      Object.assign(state, initialState)
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      (action) => action.type.startsWith('calendar/') && action.type.endsWith('/pending'),
      (state) => {
        state.loading = true
      }
    )
  }
})

export const {setLoading, setError, setCalendarList, resetState} = calendarSlice.actions

// Selectors
export const selectCalendarList = (state) => state.calendar.calendar
export const selectCalendarLoading = (state) => state.calendar.loading
export const selectCalendarError = (state) => state.calendar.error

export default calendarSlice.reducer
